import React from 'react';
import { TemplateType } from '../TemplateType';
import usePdfContent, { PdfContentParams } from '../usePdfContent';

import PdfContent from 'apps/Pdf/components/common/PdfContent';
import Title from 'apps/Pdf/components/common/Title';
import H2 from 'apps/Pdf/components/common/H2';
import Loading from 'apps/Pdf/components/common/Loading';
import P from 'apps/Pdf/components/common/P';

import PersonalData from 'apps/Pdf/templates/MainContract/components/PersonalData';
import CompanyData from 'apps/Pdf/templates/MainContract/components/CompanyData';
import useColorStyles from 'apps/Pdf/styles/colors';
import Signature from 'apps/Pdf/components/Signature/Signature';
import { LTIPTerminationContent } from './LTIPTerminationInterface';
import { ContractPhysicalData, ContractLegalData } from 'stores/workflowStores/workflowPersonalDataStore/model';
import { PersonType } from 'enums';
import { PdfCategory } from '../Interfaces';

const LTIPTermination = (params: PdfContentParams) => {
  const pdfContent = usePdfContent<LTIPTerminationContent>({ templateType: TPL_LTIP_TERMINATION, category: PdfCategory.SIGNATURE, ...params });
  const data = pdfContent?.data ? pdfContent.data : ({} as LTIPTerminationContent);
  const legal = pdfContent?.data && data.clientData.personType === PersonType.LEGAL;
  const colors = useColorStyles({ code: pdfContent?.data?.header.signedVia || '' });

  return pdfContent ? (
    <PdfContent errors={pdfContent?.errors} className={colors.root} onload afterLoad={params.afterLoad}>
      <Title>Výpověď smlouvy o dlouhodobém investičním produktu</Title>

      <H2>Zákazník:</H2>

      {legal ? (
        <>
          <CompanyData data={data.clientData as ContractLegalData} />
          <H2>Zástupce zákazníka:</H2>
          <PersonalData data={(data.clientData as ContractLegalData).representative} />
        </>
      ) : (
        <PersonalData data={data.clientData as ContractPhysicalData} />
      )}

      <P>
        (dále jen „<strong>Zákazník</strong>“)
      </P>

      <P>
        tímto vypovídá Smlouvu o dlouhodobém investičním produktu, na základě které společnost WOOD Retail Investments
        a. s. zřídila pro Zákazníka dlouhodobý investiční produkt označený jako WOOD DIP (dále jen „Smlouva o DIP“), a
        to v souladu s čl. 4.1.2. Smlouvy o DIP.
      </P>

      <P>
        K ukončení Smlouvy o DIP tedy dojde uplynutím kalendářního měsíce následujícího po měsíci, v němž byla tato
        výpověď doručena.
      </P>

      <P>Touto výpovědí není dotčeno trvání Rámcové smlouvy, není-li zároveň podána výpověď Rámcové smlouvy.</P>

      <P>
        Případný zůstatek peněžních prostředků na evidenčním účtu Zákazníka bude převeden na bankovní účet zákazníka.
      </P>

      <P>
        Zákazník prohlašuje, že si je vědom toho, že zánik Smlouvy o DIP může mít za následek povinnost navrátit Daňovou
        podporu.
      </P>

      <Signature protocol={data.signedInfo} />
    </PdfContent>
  ) : params.preview ? (
    <Loading />
  ) : null;
};

const TPL_LTIP_TERMINATION: TemplateType = 'ltipTermination';

export { TPL_LTIP_TERMINATION, LTIPTermination };
